import React from 'react';
import styled, { keyframes } from 'styled-components';

import TextWIthToolTip from 'Modules/Interview/Common/TextWIthToolTip/TextWIthToolTip';
import PropTypes from 'prop-types';

function Error500({ error }) {
  const pulse = keyframes`

        0%   {top:-84px; }
        50%{top:-50px; }
        100%  { top:-84px; } 

  `;

  const Bar = styled.div`
    position: absolute;
    animation-name: ${pulse};
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  `;
  const style = {
    main: {
      textAlign: 'center',
      background: "url('/interview/second-theme/images/error-500/cloud.png')",
      width: '100%',
      height: '100vh',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    },
    img_error: {
      display: 'flex ',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
    },
    erro_404: {
      maxWidth: '600px',
      width: '100%',
      height: 'auto',
    },

    img: {
      maxWidth: '200px',
    },

    lft: {
      position: 'absolute',
      bottom: '10px',
      left: '0',
      zIndex: ' 0',
      maxWidth: '350px',
      height: 'auto',
    },
    rft: {
      position: 'absolute',
      bottom: '20px',
      right: '0',
      zIndex: '0',
      maxWidth: '350px',
      height: 'auto',
    },

    erro_404: {
      maxWidth: '535px',
      width: '100%',
    },
    animate_img: {
      position: 'absolute',
      top: '-4px',
      right: '40vh',
    },

    position_relative: {
      position: 'relative',
    },
    img_fluid: {
      height: 'auto',
      maxWidth: '200px',
    },
    fw_bold: {
      fontWeight: '700',
      fontSize: 'calc(1.3rem + .6vw)',
      marginTop: '0',
      marginBottom: '0.5rem',
      lineHeight: '1.2',
    },
  };

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
        crossOrigin="anonymous"
      ></link>
      <div style={style.main}>
        <div style={style.img_error}>
          <div style={style.position_relative}>
            <img style={style.erro_404} src="/interview/second-theme/images/error-500/error500.png" alt="error500" />
            <div style={style.animate_img}>
              <Bar>
                <img style={style.img_fluid} src="/interview/second-theme/images/error-500/Character.png" alt="character" />
              </Bar>
            </div>
            {error !== 1 ? (
              <>
                <h3 style={style.fw_bold}>
                  <TextWIthToolTip text={'Internal Server Error'} />
                </h3>
                <p>
                  <TextWIthToolTip text={'We’re experiencing an internal server problem. Please try again later.'} />
                </p>
              </>
            ) : (
              <>
                <h3 style={style.fw_bold}>
                  <TextWIthToolTip text={'Integration Partner Error'} />
                </h3>
                <p>
                  <TextWIthToolTip text={'We’re experiencing an API integration error. Please try again later.'} />
                </p>
              </>
            )}
          </div>
          <div className="">
            <img style={style.lft} src="/interview/second-theme/images/error-500/connector.png" alt="connector" />

            <img style={style.rft} src="/interview/second-theme/images/error-500/connector2.png" alt="connector2" />
          </div>
        </div>
      </div>
    </>
  );
}

Error500.propTypes = {
  error: PropTypes.number,
};

Error500.defaultProps = {
  error: 0,
};

export default Error500;
